import { userApi } from "./http";

/**
 * Fetch aggregated dashboard stats for the logged-in lawyer.
 * @returns {Promise<{
 *   totalBookings: number,
 *   pendingRequests: number,
 *   acceptedBookings: number,
 *   ongoingCases: number,
 *   rejectedBookings: number,
 *   cancelledBookings: number,
 *   monthlyEarnings: number,
 *   totalEarnings: number,
 *   pendingEarnings: number,
 *   upcomingEarnings: number,
 *   platformFeeRate: number,
 *   recentBookings: Array
 * }>}
 */
export async function fetchLawyerDashboard() {
  const { data } = await userApi.get("/bookings/lawyer/dashboard");
  return data;
}

/**
 * Fetch the full earnings breakdown + transaction list for the logged-in lawyer.
 * @returns {Promise<{
 *   totalEarnings: number,
 *   monthlyEarnings: number,
 *   pendingEarnings: number,
 *   upcomingEarnings: number,
 *   platformFeeRate: number,
 *   transactions: Array<{
 *     id: string,
 *     clientName: string,
 *     caseType: string,
 *     consultationFee: number,
 *     platformFee: number,
 *     lawyerEarnings: number,
 *     paymentStatus: 'completed',
 *     date: string,
 *     bookingDate: string,
 *     bookingTime: string
 *   }>
 * }>}
 */
export async function fetchLawyerEarnings() {
  const { data } = await userApi.get("/bookings/lawyer/earnings");
  return data;
}
